import React, {useEffect, useState} from 'react';
import {getAllPublicProducts} from "../../services/ProductRepository";
import {ProductItem} from "../product/ProductItem";
import {useError} from "../../hooks/useError";

export function Store() {

    const [products, setProducts] = useState(null);
    const {setErrorMessage} = useError();

    useEffect(() => {
        if (products === null) {
            getAllPublicProducts(setErrorMessage).then(products => {
                setProducts(products)
            }).catch(err => console.log(err));
        }

    }, [products])


    if (products != null) {
        return (
            <div className={"bg-neutral-3 d-flex flex-column justify-content-start "}
                 style={{fontFamily: "Poppins", minHeight:"100vh"}}>

                <div className={"container pt-3 mb-5"}>

                    <div className={"row"}>
                        {
                            products.map(token => (
                                    <ProductItem className={"col col-md-6 col-sm-12 m-3"} token={token}/>
                            ))
                        }

                    </div>

                </div>

                <div className={"mb-5"}></div>


            </div>
        )
    }

}